export const NUVEM_ENVIO_ORDERS_ROUTES = {
  ordersNuvemEnvioPrintLabelStatus: '/orders/nuvem-envio/print-label/status',
  ordersNuvemEnvioPrintDocuments: '/orders/nuvem-envio/print-documents',
  ordersNuvemEnvioAsyncPrintLabelStatus:
    '/orders/nuvem-envio/print-label/async-status',
};
